import * as React from 'react'
import {Button, PRIORITY} from 'wix-ui-tpa/Button'
import {useTranslation} from '@wix/yoshi-flow-editor'
import s from './buttons.scss'
import {ButtonsProps} from '.'

export const Buttons = ({selectedTickets, onTicketsClick, onCheckoutClick}: ButtonsProps) => {
  const {t} = useTranslation()

  return (
    <div className={s.buttons}>
      {onTicketsClick ? (
        <Button priority={PRIORITY.basicSecondary} onClick={onTicketsClick}>
          {t('seatings_tickets', {count: selectedTickets})}
        </Button>
      ) : null}
      {onCheckoutClick ? (
        <Button
          className={!onTicketsClick ? s.fullWidth : undefined}
          disabled={!selectedTickets}
          onClick={onCheckoutClick}
        >
          {t('seatings_checkout')}
        </Button>
      ) : null}
    </div>
  )
}
